import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import zipObjectDeep from 'lodash/zipObjectDeep';
import { transformDelegateAdHocFormValues } from '../../../../../paymentJourneyRedesign/helpers/confirmPurchase/delegate/transformDelegateAdHocFormValues';

export function transformAdHocValues(name, values, questions) {
  return transformToLegacyModel(
    name,
    transformDelegateAdHocFormValues(values, {
      sets: [
        {
          formInputs: cloneDeep(questions),
        },
      ],
    }),
  );
}

function transformToLegacyModel(name, values) {
  let result = {};

  Object.keys(values[name]).forEach((longName) => {
    const value = values.adHocAnswers[longName].map((v) => v.value);
    result = merge(result, zipObjectDeep([longName], [value]));
  });

  return {
    ...result,
    profile: transformProfileValues(result.profile),
  };
}

function transformProfileValues(profile = {}) {
  const result = Object.keys(profile).reduce((acc, key) => {
    acc[key] = profile[key][0] ?? '';
    return acc;
  }, {});

  if (!['US', 'CA', 'MX'].includes(result.country)) {
    delete result.state;
  }

  return result;
}
